<div class="loading-animation-container" [ngClass]="loaderSize" [@elemShow]>
  <div class="dot" [ngClass]="{ 'in-primary': !isInPrimary}" ></div>
  <div class="dot" [ngClass]="{ 'in-primary': !isInPrimary}" ></div>
  <div class="dot" [ngClass]="{ 'in-primary': !isInPrimary}" ></div>
</div>
